import React, { useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import EditableDataGridContext from '../Context/EditableDataGridContext';

const RenderInBody = props => {
  const popup = useRef(null);
  const { ownerGrid } = useContext(EditableDataGridContext);

  useEffect(() => {
    popup.current = document.createElement('div');
    if (ownerGrid) {
      popup.current.dataset.ownerGrid = ownerGrid;
      popup.current.tabIndex = 1;
    }
    document.body.appendChild(popup.current);
    ReactDOM.render(props.children, popup.current);

    return () => {
      ReactDOM.unmountComponentAtNode(popup.current);
      document.body.removeChild(popup.current);
      popup.current = null;
    };
  }, []);

  useEffect(() => {
    if (popup.current) {
      ReactDOM.render(props.children, popup.current);
    }
  }, [props.children, popup.current]);

  return <div {...props} children={null} />;
};

export default RenderInBody;
